export default __webpack_public_path__ + "static/media/A25.70922ef3.png";